export const WEBSOCKET_EVENT = {
  INCOMING_CALL: "IncomingCall",
  CALL_END: "CallEnd",
  INCOMING_RATING: "ratingEvent",
  RECEIVED_MESSAGE: "ReceivedMessage",
  UNREAD_MSG_INGO: "UnreadMsgInfo",
  PURCHASED_AEVA_PRODUCT: "PurchasedSmsPackage",
  CHECKOUT_PAYMENT: "CheckoutPayment",
};
